import { connect } from "react-redux";
import { isRouteLogin } from "../utils";


function _Body({ children, currentRoute }) {

   const isLogin = isRouteLogin(currentRoute);
   
   const bgClasses = isLogin ? 'bg-gradient-to-br from-orange-500 to-orange-300' : '';

   return <div className={bgClasses}>
      {children}
   </div>
}

const mapStateToProps = state => ({ currentRoute: state.currentRoute });
const Body = connect(mapStateToProps)(_Body);

export default Body;